import { useState } from 'react';
import { Button, Theme, Typography } from '@mui/material';
import { createStyles, makeStyles } from '@mui/styles';
import { DocumentIngestion_ExtractFieldsResult, EstateType } from 'queries';

import { EstateDetailDocumentIngestionModal } from './estate-detail-document-ingestion-modal';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    container: {
      backgroundColor: '#5ED1F0',
      borderRadius: theme.spacing(1.5),
      padding: theme.spacing(3, 2),
      display: 'flex',
      textAlign: 'left',
      justifyContent: 'space-between',
      alignItems: 'center',
      marginBottom: theme.spacing(2),
    },
    prefillButton: {
      backgroundColor: '#D351E1',
      color: '#FFFFFF',
      borderRadius: theme.spacing(1.5),
    },
    prefillCloseButton: {
      color: '#FFFFFF',
    },
  }),
);

type EstateDetailDocumentIngestionPromptProps = {
  portalId: string;
  onExtractFields: (extractedFields: DocumentIngestion_ExtractFieldsResult) => void;
  estateType: EstateType;
};

export const EstateDetailDocumentIngestionPrompt = ({
  estateType,
  portalId,
  onExtractFields,
}: EstateDetailDocumentIngestionPromptProps) => {
  const classes = useStyles();
  const [showDocumentIngestionModal, setShowDocumentIngestionModal] = useState(false);

  const handleExtractFields = (extractedFields: DocumentIngestion_ExtractFieldsResult) => {
    onExtractFields(extractedFields);
    setShowDocumentIngestionModal(false);
  };

  return (
    <div className={classes.container}>
      <div>
        <Typography variant="h5">Save time! Upload document and autofill form.</Typography>
        <Typography variant="body2">
          Try uploading a death certificate or drivers license.
        </Typography>
      </div>
      <div>
        <Button
          className={classes.prefillButton}
          color="primary"
          onClick={() => setShowDocumentIngestionModal(true)}
          variant="contained"
          type="button"
        >
          Prefill from document &nbsp; <Typography variant="h5">🪄</Typography>
        </Button>
      </div>
      {showDocumentIngestionModal && (
        <EstateDetailDocumentIngestionModal
          portalId={portalId}
          onClose={() => setShowDocumentIngestionModal(false)}
          onExtractFields={handleExtractFields}
          showModal={showDocumentIngestionModal}
          setShowModal={setShowDocumentIngestionModal}
          estateType={estateType}
        />
      )}
    </div>
  );
};
